import React from 'react';
const config = require('../../config.json');

export default function SearchCardView(props) {
    const {searchResult, handleShow} = props;

    /*const handleImageError=(tid)=>{
      console.log("tid :", tid);
      document.getElementById(tid).src="images/cat1.png";
    }*/

    const handleImageError = (event) => {
      event.target.src = "images/cat1.png";
    };

    return (
      <section className="catagory_section">
        {searchResult.length > 0 && (
          <div className="catagory_container">
            <div className="container py-2">
              <div className="row g-3">
                {searchResult.map((item, index) => (
                  <div
                    key={index}
                    className="col-12 col-sm-6 col-md-4 d-flex align-items-stretch"
                    style={{
                      paddingLeft: 6,
                      paddingRight: 6,
                      marginBottom: 12,
                    }}
                  >
                    <div
                      className="card shadow-lg border-0 d-flex flex-column justify-content-between h-100 mx-auto"
                      style={{
                        borderRadius: 18,
                        transition: 'transform 0.18s, box-shadow 0.18s',
                        cursor: 'pointer',
                        background: '#fff',
                        minHeight: 260,
                        height: '100%',
                        width: '100%',
                        maxWidth: 340,
                        minWidth: 0,
                        display: 'flex',
                        flexDirection: 'column',
                        boxSizing: 'border-box',
                      }}
                      onClick={event => handleShow(event, item)}
                      onMouseOver={e => {
                        e.currentTarget.style.transform = 'translateY(-6px) scale(1.025)';
                        e.currentTarget.style.boxShadow = '0 8px 32px rgba(11,182,215,0.10)';
                      }}
                      onMouseOut={e => {
                        e.currentTarget.style.transform = '';
                        e.currentTarget.style.boxShadow = '0 2px 12px rgba(6,53,71,0.10)';
                      }}
                    >
                      <div
                        className="img-box d-flex justify-content-center align-items-center"
                        style={{
                          paddingTop: 14,
                          margin: 0,
                          width: '100%',
                          minHeight: 120,
                        }}
                      >
                        <img
                          src={`${config.s3.bookPoster}${item.Accession_No}${".jpeg"}`}
                          alt="Book Poster"
                          onError={handleImageError}
                          style={{
                            width: 110,
                            height: 150,
                            objectFit: 'cover',
                            borderRadius: 12,
                            boxShadow: '0 4px 18px #0bb6d733',
                            background: '#fff',
                            border: '1px solid #e0e0e0',
                            filter: 'brightness(1.10) contrast(1.10)',
                            transition: 'box-shadow 0.2s, filter 0.2s',
                            margin: 0,
                            padding: 0,
                            display: 'block',
                          }}
                        />
                      </div>
                      <div
                        className="detail-box text-center px-2 pt-0"
                        style={{
                          marginTop: 0,
                          paddingLeft: 2,
                          paddingRight: 2,
                          wordBreak: 'break-word',
                        }}
                      >
                        <h5
                          style={{
                            fontWeight: 700,
                            color: '#0bb6d7',
                            fontSize: '1.08rem',
                            marginBottom: 4,
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                          }}
                        >
                          {item.Accession_No}
                        </h5>
                        <p
                          style={{
                            fontWeight: 600,
                            color: '#063547',
                            fontSize: '1.01rem',
                            marginBottom: 2,
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            maxWidth: '100%',
                          }}
                        >
                          <i className='fa fa-book me-2'></i>{item.Book_Title}
                        </p>
                        <p
                          style={{
                            color: '#555',
                            fontSize: '0.97rem',
                            marginBottom: 0,
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            maxWidth: '100%',
                          }}
                        >
                          <i className="fa fa-user me-2" aria-hidden="true"></i>{item.Book_Author}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </section>
    );
}
